import type { FunctionComponent } from 'react'
import React, { useContext } from 'react'

import { PillButtonPage } from '../../../../../shared/pages/PillButtonPage'
import { ToolContext } from '../../../../../shared/state/appContext'
import globalStyles from '../../../../../shared/styles/GlobalStyles.module.scss'
import { trackAppointmentBookingSelection } from '../../../../../shared/utils/tracking/tracking'
import { DescribeCaseFlow, TechSystemFlow } from '../../../pageFlowData'
import { techSystemData } from './data'

export const TechSystem: FunctionComponent = () => {
  const { state, dispatch } = useContext(ToolContext)
  const {
    tech: { techSystem, techDevice },
    triage: { type },
  } = state

  const handleTracking = (id: string, index: number) => {
    trackAppointmentBookingSelection(type, TechSystemFlow.VIEW_NAME, { id, index })
  }

  const handleDispatch = (id: string) => {
    dispatch({ type: 'UPDATE_TECH_SYSTEM', data: id })
    dispatch({ type: 'UPDATE_STEP', data: DescribeCaseFlow.STEP })
    dispatch({ type: 'UPDATE_PROGRESS_VALUE', data: DescribeCaseFlow.PROGRESS_VALUE })
  }

  const chooseButtons = () => {
    switch (techDevice) {
      case 'desktop':
      case 'laptop':
        return techSystemData.laptopOrDesktopButtons
      case 'mobiles':
        return techSystemData.mobileButtons
      case 'tablet':
        return techSystemData.tabletButtons
      default:
        return techSystemData.buttons
    }
  }

  const handleSubmit = (id: string, index: number) => {
    handleTracking(id, index)
    handleDispatch(id)
  }

  const { imgObj, title, standFirst } = techSystemData
  const buttons = chooseButtons()

  return (
    <div className={globalStyles.fullWidthButton}>
      <PillButtonPage
        buttons={buttons}
        defaultValue={techSystem}
        handleSubmit={handleSubmit}
        imgObj={imgObj}
        standFirst={standFirst}
        title={title}
      />
    </div>
  )
}
